var chunkToChildrenMap = {
	"656": [
		96,
		864,
		604,
		763,
		590,
		308,
		834
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };